//import Libraries
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
//import Components
import {Form, FormGroup, Label, Input} from 'reactstrap'

import DepartmentNormalFormLine   from './FormLines/DepartmentNormalFormLine';
import DepartmentSliderFormLine   from './FormLines/DepartmentSliderFormLine';
import DepartmentCardFormLine   from './FormLines/DepartmentCardFormLine';

//import Styles
// import './AdminOrderableFormLine.css'
import * as departmentActions from '../../HomepageManager/actions/departmentActions';
import * as imageActions from '../../actions/imageActions';
import { storage } from 'firebase';

class AdminDepartmentForm extends Component {

    constructor(props) {
        super(props);

        const { type, name, content } = props.data;
        const {items} = props.data;

        const promotion = props.data.promotion ? props.data.promotion : false;

        this.state = {
            contentType : type,
            koName: name['ko'],
            koContent: content['ko'],
            enName: name['en'],
            enContent: content['en'],
            promotion
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot){
        if(prevProps.editing && !this.props.editing) {
            const { name, content } = this.props.data;
            this.setState({
                koName: name['ko'],
                koContent: content['ko'],
                enName: name['en'],
                enContent: content['en'],
            })
        }
        if (prevProps.data.name !== this.props.data.name ||
            prevProps.data.content !== this.props.data.content) {
            const { name, content } = this.props.data;
            this.setState({
                koName: name["ko"],
                koContent: content["ko"],
                enName: name["en"],
                enContent: content["en"]
            });
        }
        if(prevProps.data.type !== this.props.data.type) {
            this.setState({
                contentType : this.props.data.type
            })
        }
    }

    toggleEditing = () => {
        const { id, name, content } = this.props.data;
        this.props.askCancleEditing(() => {
            this.setState(prevState => ({
                koName: name["ko"],
                koContent: content["ko"],
                enName: name["en"],
                enContent: content["en"],
                contentType : this.props.data.type

            }))
            this.props.toggleEditing(id);
        }, id)
    }


    handleOnChange = (e) => {
        this.setState({
            [e.target.name] : e.target.value
        })
    }

    handleCheckboxChange = (e) => {
        this.setState({
            promotion : e.target.checked
        })
    }

    render(){
        const {contentType} = this.state;
        const {askCancleEditing, editing, editAnything, data, index, dbPath, storagePath,
                onDataOrderSwitch, onUpdateData, onRemoveData } = this.props;

        const renderFormLine = contentType === 'normal' ? 
                                                <DepartmentNormalFormLine 
                                                    askCancleEditing={askCancleEditing}
                                                    onToggleEditing={this.toggleEditing}
                                                    editing={editing}
                                                    editAnything={editAnything}
                                                    data={data}
                                                    index={index}
                                                    onUpdate={onUpdateData}
                                                    onRemove={onRemoveData}
                                                    onDataOrderSwitch={onDataOrderSwitch}
                                                    dbPath={dbPath}
                                                    storagePath={storagePath}
                                                    type={contentType}

                                                    enName={this.state.enName} 
                                                    enContent={this.state.enContent} 
                                                    koName={this.state.koName} 
                                                    koContent={this.state.koContent} 

                                                    handleOnChange={this.handleOnChange}
                                                    promotion={this.state.promotion} 
                                                /> 
                                                : contentType==='slider' ? 
                                                <DepartmentSliderFormLine  
                                                    askCancleEditing={askCancleEditing}
                                                    onToggleEditing={this.toggleEditing}
                                                    editing={editing}
                                                    editAnything={editAnything}
                                                    data={data}
                                                    index={index}
                                                    onUpdate={onUpdateData}
                                                    onRemove={onRemoveData}
                                                    onDataOrderSwitch={onDataOrderSwitch}
                                                    dbPath={dbPath}
                                                    storagePath={storagePath}
                                                    type={this.state.contentType}

                                                    enName={this.state.enName} 
                                                    enContent={this.state.enContent} 
                                                    koName={this.state.koName} 
                                                    koContent={this.state.koContent} 

                                                    handleOnChange={this.handleOnChange}
                                                    promotion={this.state.promotion} 
                                                /> 
                                                : 
                                                <DepartmentCardFormLine 
                                                    askCancleEditing={askCancleEditing}
                                                    onToggleEditing={this.toggleEditing}
                                                    editing={editing}
                                                    editAnything={editAnything}
                                                    data={data}
                                                    index={index}
                                                    onUpdate={onUpdateData}
                                                    onRemove={onRemoveData}
                                                    onDataOrderSwitch={onDataOrderSwitch}
                                                    dbPath={dbPath}
                                                    storagePath={storagePath}
                                                    type={this.state.contentType}

                                                    enName={this.state.enName} 
                                                    enContent={this.state.enContent} 
                                                    koName={this.state.koName} 
                                                    koContent={this.state.koContent} 

                                                    handleOnChange={this.handleOnChange}
                                                    promotion={this.state.promotion} 
                                                />
        return (
            <div className="sub-category">
                <Form inline>
                    <div className="IndexLabel">{this.props.index+1}</div>
                    <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                        <Label className="mr-sm-2">타입</Label>
                        <Input 
                            type="select" 
                            name="contentType" 
                            size={"sm"}
                            onChange={this.handleOnChange} 
                            disabled={!this.props.editing} 
                            value={this.props.editing ? this.state.contentType : this.props.data.type}
                        >
                            <option value="normal">일반</option>
                            <option value="slider">슬라이더</option>
                            <option value="cards">카드</option>
                        </Input>
                    </FormGroup>
                    <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                        <Label className="mr-sm-2">Promotion</Label>
                        <Input 
                            type="checkbox" 
                            name="promotion" 
                            disabled={!this.props.editing}
                            checked={this.state.promotion}
                            onChange={this.handleCheckboxChange}
                        />
                    </FormGroup>
                </Form>
                {
                    renderFormLine  
                }
            </div>
        );
    }
}


const mapDispatchToProps = (dispatch) => {
    return {
        onDataOrderSwitch : (dbPath, aIndex, bIndex) => {
            dispatch(departmentActions.departmentDataOrderSwitch(dbPath, aIndex, bIndex))
        },
        onUpdateData: (path, id, data) => {
            dispatch(departmentActions.updateDepartment(path, id, data));
        },
        onRemoveData: (path, storagePath, data) => {
            dispatch(departmentActions.removeDepartment(path, storagePath, data));
        },
        onDeleteImage : (storagePath, id, successFunc, failedFunc) => {
            dispatch(imageActions.deleteImage(storagePath, id, successFunc, failedFunc));
        }
    }
}

export default connect(null, mapDispatchToProps)(AdminDepartmentForm);

AdminDepartmentForm.propTypes = {
    data : PropTypes.object.isRequired,
    storagePath : PropTypes.string.isRequired,
}

AdminDepartmentForm.defaultProps = {
    onUpdate : null,
    onRemove : null,
    onOrderUp : null,
    onOrderDown : null,
}


// WEBPACK FOOTER //
// ./src/pages/Admin/Components/AdminDepartmentFormManager/AdminDepartmentForm.js